import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/sys/orderSacrificeManage/grave',
    method: 'post',
    data
  })
}
export function getDetail(data) {
  return request({
    url: '/sys/orderSacrificeManage/details',
    method: 'post',
    data
  })
}
export function uploadImg(data) {
  return request({
    url: '/sys/orderSacrificeManage/upload',
    method: 'post',
    data
  })
}
export function delImg(data) {
  return request({
    url: '/sys/orderSacrificeManage/deleteFile',
    method: 'post',
    data
  })
}